import CampaignTngDisbursementPanel from "./campaignTngDisbursementPanel.container";

export default CampaignTngDisbursementPanel;
